import React from "react";
import THFila from "../../Componentes/THFila";
import { numberFormat } from "../../Formatos";
interface Props {
    monto: number
}
export default function MontoTh({ monto }: Props) {
    return <THFila width="160px" align='right'>{numberFormat(monto)}</THFila>
}